var React = require('react');

function Arrows (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4.16504 16.8335H11.165V23.8335","stroke":"#3D75FF","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M22.834 12.167H15.834V5.16699","stroke":"#3D75FF","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M15.834 12.1667L24.0007 4","stroke":"#3D75FF","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M3 25.0002L11.1667 16.8335","stroke":"#3D75FF","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

Arrows.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = Arrows;

Arrows.default = Arrows;
